module.exports = __webpack_public_path__ + "static/media/A18040103_10002_4.d5494bb1.jpg";